import React from "react";
import type { IIcon } from "./icons.types";

const Search: React.FC<IIcon> = ({
  width = 20,
  height = 20,
  color = "currentColor"
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.4 17.6L17.1 14.3L17.2 14.1C17.8 13 18.1 11.8 18.1 10.6C18.1 8.6 17.3 6.7 15.9 5.3C14.4 3.8 12.5 3 10.5 3C6.4 3 3 6.4 3 10.5C3 12.5 3.8 14.4 5.2 15.8C6.6 17.2 8.5 18 10.5 18C11.7 18 13 17.7 14 17.1L14.2 17L17.5 20.3C18 20.8 18.5 21 19 21C19.5 21 20 20.8 20.4 20.4C20.8 20 21 19.5 21 19C21 18.5 20.8 18 20.4 17.6ZM10.5 15.2C7.9 15.2 5.8 13.1 5.8 10.5C5.8 7.9 7.9 5.8 10.5 5.8C13.1 5.8 15.2 7.9 15.2 10.5C15.2 13.1 13.1 15.2 10.5 15.2Z"
      fill={color}
    />
  </svg>
);

export { Search };
